// https://github.com/visionmedia/debug/blob/78ae6c94122a5c23263b6ea6def0d7ead474fc66/src/debug.js#L44
/**
 * 简单快捷的hash算法
 * @param str
 */
export function hashStr(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}
//# sourceMappingURL=hash-str.js.map